import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { withRouter } from 'react-router';

import PageBase from '../../../app/PageBase';
import Table from '../../table/MsTable';
import AccountForm from './AccountForm';
import { getAccountsByHolding, accountByUserId, deleteAccount, save, statusUpdate, accountByHoldingId } from '../../../redux/actions/accountActions';
import { companyByHoldingId } from '../../../redux/actions/companyActions';
import DeleteConfirmationDialog from '../../util/Dialogs/DeleteConfirmationDialog';


import { setAccountData } from '../../../redux/account';

const mapStateToProps = state => ({
  open: state.accountReducer.open,
  accountId: state.accountReducer.accountId,
  accountList: state.accountReducer.accountList,
});

const mapDispatchToProps = {
  setAccountData,
  getAccountsByHolding,
  accountByUserId,
  deleteAccount,
  accountByHoldingId,
  companyByHoldingId,
  save,
  statusUpdate,
};

class AccountContainer extends Component {


  static propTypes = {

  };

  constructor(props) {

    super(props);

    this.state = {
      data: {},
      deleteOpen: false,
      showTable: true,
      showTableActions: false,
    };

    this.onChangeData = this.onChangeData.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);

    this.getAccounts = this.getAccounts.bind(this);
    this.closeDeleteDialog = this.closeDeleteDialog.bind(this);

  }


  componentWillMount() {

    this.getAccounts();

  }

  getAccounts() {

    const { user, getAccountsByHolding, companyByHoldingId, setAccountData } = this.props;

    getAccountsByHolding(user.context.idHolding).then(response => setAccountData({ accountList: response }));
    companyByHoldingId(user.context.idHolding).then(response => setAccountData({ companyList: response }));

  }

  onChangeData = (data) => {

    this.setState({ data, showTableActions: Object.keys(data).length !== 0 });
    this.props.setAccountData({ accountId: data[Object.keys(data)[0]] ? data[Object.keys(data)[0]].idUser : undefined, accountData: data[Object.keys(data)[0]] });

  }

  onSwitchChange = (data) => {

    const { statusUpdate } = this.props;
    const updateData = { idUser: data.idUser, active: !data.active };

    return statusUpdate(updateData).then(() => this.getAccounts(), (errors) => {

      throw errors;

    });


  }

  handleCreateClick = () => {

    this.props.history.push('/account/form/');
    this.props.setAccountData({ accountId: null });

  }

  handleEditClick = () => {

    this.props.history.push('/account/form/');

  }

  handleDeleteClick = () => this.setState({ deleteOpen: true })

  closeDeleteDialog(confirmDelete) {

    if (confirmDelete) {

      this.onDeleteConfirm();

    } else {

      this.props.setAccountData({ open: false, accountData: null });
      this.setState({ data: {}, showTableActions: false, deleteOpen: false });

    }


  }


  onDeleteConfirm() {

    const { deleteAccount, accountId } = this.props;
    deleteAccount(accountId).then(() => {

      this.getAccounts();

    }, (errors) => {

      throw errors;

    });

  }

  handleClose = () => {

    this.props.setAccountData({ open: false, accountData: null });
    this.setState({ data: {}, showTableActions: false });

  }

  handleCloseAndReload = () => {

    this.props.setAccountData({ open: false, accountData: null });
    this.setState({ data: {}, showTableActions: false });
    this.getAccounts();

  }


  render() {

    const { accountList, open } = this.props;
    const { showTableActions, deleteOpen } = this.state;


    return (
      <div>
        {!open && !deleteOpen && (
          <PageBase
            title={I18n.t('menu.users')}
            navigation={`Configurações -> ${I18n.t('menu.users')}`}
            showCreateButton={!showTableActions}
            showEditButton={showTableActions}
            showDeleteButton={showTableActions}
            handleCreateClick={this.handleCreateClick}
            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
          >
            {
              accountList && (
                <Table
                  data={accountList}
                  entryKey="idUser"
                  paginate
                  onPaginate={this.onPaginate}
                  toolbar
                  onSelectionChange={this.onChangeData}
                  onSwitchChange={this.onSwitchChange}
                  tableDef={[
                    { name: 'cpf', label: 'CPF' },
                    { name: 'name', label: I18n.t('fields.name') },
                    { name: 'email', label: 'Email' },
                    { name: 'login', label: 'Login' },
                    { name: 'active', label: I18n.t('fields.active'), switchable: true },

                  ]}
                />
              )
            }


          </PageBase>
        )
        }



        <DeleteConfirmationDialog
          open={deleteOpen}
          onClose={this.closeDeleteDialog}
        />


      </div>
    );

  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountContainer));



// WEBPACK FOOTER //
// ./src/components/tracker/User/AccountContainer.js